module.exports = __webpack_public_path__ + "img/more-opts.a4e8be31.svg";